var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7h10yo1v7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 555",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61683"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11280",
    style: {
      clipPath: "url(#7h10yo1v7a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61587"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9418",
    d: "M-4029.992-4400.679a10.849 10.849 0 0 1 7.96 3.578 13.6 13.6 0 0 1 1.168 1.423 1.975 1.975 0 0 1 .016 2.368 11.289 11.289 0 0 1-7.3 4.854 9.889 9.889 0 0 1-7.795-1.957 12.391 12.391 0 0 1-2.754-2.8 2.012 2.012 0 0 1-.06-2.442 11.358 11.358 0 0 1 7.386-4.872c.517-.094 1.048-.117 1.379-.152zm-.027 1.377c-.3.035-.814.067-1.318.161a9.96 9.96 0 0 0-6.249 4.193.72.72 0 0 0 .042.981 20.941 20.941 0 0 0 1.733 1.894 8.6 8.6 0 0 0 7.69 2.219 9.918 9.918 0 0 0 6.112-4.184.709.709 0 0 0-.014-.913 13.865 13.865 0 0 0-.666-.84 9.512 9.512 0 0 0-7.331-3.509z",
    transform: "translate(4039.803 4404.49)",
    style: {
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9419",
    d: "M-3991.435-4373.2a3.289 3.289 0 0 1-3.408-3.454 3.285 3.285 0 0 1 3.4-3.415 3.342 3.342 0 0 1 3.434 3.494 3.258 3.258 0 0 1-3.426 3.375zm.016-1.376a1.979 1.979 0 0 0 2.038-2.069 1.978 1.978 0 0 0-2.057-2.048 1.984 1.984 0 0 0-2.06 2.09 1.981 1.981 0 0 0 2.079 2.027z",
    transform: "translate(4001.439 4386.641)",
    style: {
      strokeWidth: ".25px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewQuestionIcon);
export default __webpack_public_path__ + "static/media/ViewQuestionIcon.c9609257a093fd521917e7b5f2cb6bcb.svg";
export { ForwardRef as ReactComponent };